import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import { Button, Colors } from 'advenio-components'

var Card = styled.div`
  background: #FFFFFF;
  border: 1px solid ${Colors.gray200};
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
`

var IconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  background: ${function (props) { return props.bgColor || '#F5F6FA' }};
  color: ${function (props) { return props.textColor || '#637381' }};
`

var DocName = styled.h4`
  margin: 0 0 8px 0;
  font-size: 15px;
  font-weight: 600;
  color: #212B36;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

var MetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
  flex-wrap: wrap;
`

var MetaText = styled.span`
  font-size: 12px;
  color: #637381;
`

var VersionBadge = styled.span`
  background: ${Colors.blue500};
  color: #FFFFFF;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
`

var CardFooter = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

var MIME_ICONS = {
  'application/pdf': { label: 'PDF', bg: '#FFEBEE', color: '#E53935' },
  'application/msword': { label: 'DOC', bg: '#E3F2FD', color: '#1565C0' },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { label: 'DOC', bg: '#E3F2FD', color: '#1565C0' },
  'application/vnd.ms-excel': { label: 'XLS', bg: '#E8F5E9', color: '#2E7D32' },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': { label: 'XLS', bg: '#E8F5E9', color: '#2E7D32' },
  'application/vnd.ms-powerpoint': { label: 'PPT', bg: '#FFF3E0', color: '#E65100' },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': { label: 'PPT', bg: '#FFF3E0', color: '#E65100' },
  'image/jpeg': { label: 'IMG', bg: '#F3E5F5', color: '#7B1FA2' },
  'image/png': { label: 'IMG', bg: '#F3E5F5', color: '#7B1FA2' },
  'text/plain': { label: 'TXT', bg: '#ECEFF1', color: '#455A64' }
}

class DocumentCard extends Component {
  formatFileSize = (bytes) => {
    if (!bytes) return '0 B'
    var sizes = ['B', 'KB', 'MB', 'GB']
    var i = Math.floor(Math.log(bytes) / Math.log(1024))
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i]
  }

  getIcon = (mime) => {
    var icon = MIME_ICONS[mime]
    if (icon) return icon
    return { label: 'DOC', bg: '#F5F6FA', color: '#637381' }
  }

  handleClick = () => {
    this.props.onClick(this.props.document.id)
  }

  handleDistribute = (e) => {
    e.stopPropagation()
    this.props.onDistribute(this.props.document.id)
  }

  render () {
    var doc = this.props.document
    var icon = this.getIcon(doc.mime_type)
    var dateStr = doc.created_at ? moment(doc.created_at).format('DD-MM-YYYY') : '-'

    return (
      <Card onClick={this.handleClick}>
        <div>
          <IconContainer bgColor={icon.bg} textColor={icon.color}>
            {icon.label}
          </IconContainer>
          <DocName title={doc.name}>{doc.name}</DocName>
          <MetaInfo>
            <MetaText>{this.formatFileSize(doc.file_size)}</MetaText>
            <MetaText>{dateStr}</MetaText>
            {doc.version_count > 0 && (
              <VersionBadge>{'v' + doc.version_count}</VersionBadge>
            )}
          </MetaInfo>
        </div>
        <CardFooter>
          <Button
            default
            small
            onClick={this.handleDistribute}
          >
            Distribuir
          </Button>
        </CardFooter>
      </Card>
    )
  }
}

DocumentCard.propTypes = {
  document: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onDistribute: PropTypes.func.isRequired
}

export default DocumentCard



// WEBPACK FOOTER //
// ./src/Components/Documents/DocumentCard/index.jsx